/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { PasswordCredentialParams } from './PasswordCredentialParams';
import {
    PasswordCredentialParamsFromJSON,
    PasswordCredentialParamsFromJSONTyped,
    PasswordCredentialParamsToJSON,
} from './PasswordCredentialParams';

/**
 * 
 * @export
 * @interface PasswordCredential
 */
export interface PasswordCredential {
    /**
     * 
     * @type {CredentialType}
     * @memberof PasswordCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PasswordCredentialParams}
     * @memberof PasswordCredential
     */
    params: PasswordCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof PasswordCredential
     */
    label?: string;
}

/**
 * Check if a given object implements the PasswordCredential interface.
 */
export function instanceOfPasswordCredential(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function PasswordCredentialFromJSON(json: any): PasswordCredential {
    return PasswordCredentialFromJSONTyped(json, false);
}

export function PasswordCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': CredentialTypeFromJSON(json['type']),
        'params': PasswordCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function PasswordCredentialToJSON(value?: PasswordCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': CredentialTypeToJSON(value.type),
        'params': PasswordCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

